import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import PopUpWatchDocument from "./PopUpWatchDocument";
import FileMimeType from "../../../../../../utils/FileMimeType";
import { AdminService } from "../../../../../../services/AdminService";
import { toast } from "react-toastify";

const StudyFolderMenuShowElementAnnexe = ({
	fakeDataProject,
	titleSection,
	input,
	onClickDelete,
	onClickUpload,
	className,
	onDragEndDropEnd,
}) => {
	const [items, setItems] = useState(fakeDataProject);
	const [showPopups, setShowPopups] = useState(Array(fakeDataProject.length).fill(false));

	const handleDownload = (url, filename) => {
		if (url && filename) {
			AdminService.getFile(url, filename);
			toast.success('Téléchargement en cours');
		} else {
			toast.error('Une erreur est survenue');
		}
	};

	const togglePopup = (index) => {
		const updatedPopups = [...showPopups];
		updatedPopups[index] = !updatedPopups[index];
		setShowPopups(updatedPopups);
	};

	const onDragEnd = (result) => {
		if (!result.destination) return;

		const newItems = Array.from(items);
		const [reorderedItem] = newItems.splice(result.source.index, 1);
		newItems.splice(result.destination.index, 0, reorderedItem);

		setItems(newItems);
		onDragEndDropEnd(newItems);
	};

	return (
		<div className="section-study-folder-menu-content-element-container">
			<div className="section-study-folder-menu-content-element-container-element">
				<p className="text-primary paragraph_bold color-white">{titleSection}</p>
				{input}
			</div>

			<DragDropContext onDragEnd={onDragEnd}>
				<Droppable droppableId="pdf-list" direction="horizontal">
					{(provided) => (
						<div
							className="section-study-folder-menu-content-element-container-result"
							ref={provided.innerRef}
							{...provided.droppableProps}
						>
							{items.map((plan, index) => (
								<Draggable key={plan.id} draggableId={String(plan.id)} index={index}>
									{(provided) => (
										<div
											className="section-study-folder-menu-content-element-container-result-element"
											ref={provided.innerRef}
											{...provided.draggableProps}
											{...provided.dragHandleProps}
										>
											{titleSection === "Images" ? (
												<>
													<img
														src={process.env.REACT_APP_PROD_URL + plan.imageUrl}
														alt="file"
														className="img"
														onClick={() => togglePopup(index)}
													/>
													{showPopups[index] && (
														<PopUpWatchDocument
															images={items.map(item => ({
																img: process.env.REACT_APP_PROD_URL + item.imageUrl,
																name: item.title,
																downloadLink: item.downloadUrl,
																filename: item.filename,
															}))}
															initialImageIndex={index}
															onClose={() => togglePopup(index)}
														/>
													)}
												</>
											) : (
												<div onClick={() => handleDownload(plan.downloadUrl, plan.filename)}>
													<FileMimeType mimeType={plan.mimeType} />
												</div>
											)}

											{plan.extension === "pdf" && (
												<div className="upload-pdf-study-folder">
													<img
														src="/images/pictos/add-plus-circle-primary.svg"
														alt="file"
														className="img"
														onClick={() => onClickUpload(plan.id)}
													/>
												</div>
											)}

											<img
												src="/images/pictos/red-cross.svg"
												alt={`delete file ${plan.id}`}
												className="delete-file"
												onClick={() => onClickDelete(plan.id)}
											/>

											<p className={className || "color-white"}>{plan.title}</p>
										</div>
									)}
								</Draggable>
							))}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
		</div>
	);
};

export default StudyFolderMenuShowElementAnnexe;
